import { Accordion, AccordionDetails, AccordionSummary, Box, Container, styled, Typography } from '@mui/material';
import { FC } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useLocation } from 'react-router';

const StyledFooter = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.footer ? theme.palette.footer.dark : theme.palette.grey[900],
	width: '100%',
	padding: theme.spacing(2, 0),
}));

export interface IFooterDetail {
	title: string;
	content: React.ReactNode;
}

interface IProps {
	footerDetails: IFooterDetail[];
}

const Footer: FC<IProps> = ({ footerDetails }) => {
	const pathname = useLocation().pathname;
	const pricePadding = pathname.includes('/portal/policy-renewals/make-a-change/optional-extras') ? '80px' : '0px';

	return (
		<StyledFooter id='portal-footer' style={{ paddingBottom: pricePadding }}>
			<Container>
				{footerDetails.map(({ title, content }) => (
					<Accordion
						key={title}
						sx={{
							backgroundColor: 'unset',
							color: 'common.white',
							borderRadius: 'unset',
							borderTopLeftRadius: 'unset',
							borderTopRightRadius: 'unset',

							boxShadow: 'unset',
							borderBottom: '1px solid white',
							'&:before': {
								backgroundColor: 'unset',
							},
							'&:last-of-type': {
								borderBottomLeftRadius: 'unset',
								borderBottomRightRadius: 'unset',
							},
						}}
					>
						<AccordionSummary
							sx={{ color: 'inherit' }}
							expandIcon={<ExpandMoreIcon sx={{ color: 'common.white' }} />}
							aria-controls={`${title}-content`}
							id={`${title}-header`}
						>
							<Typography>{title}</Typography>
						</AccordionSummary>
						<AccordionDetails
							sx={(theme) => ({
								backgroundColor: theme.palette.footer ? theme.palette.footer.main : theme.palette.grey[700],
							})}
						>
							{content}
						</AccordionDetails>
					</Accordion>
				))}
			</Container>
		</StyledFooter>
	);
};

export default Footer;
